import { isDefined, isNil } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { CbhIcon, type CbhIconProps, Text } from "@src/appV2/redesign/system/ui-components";

export interface PaymentDetailsLineItemProps {
  iconType: CbhIconProps["type"];
  label: string | JSX.Element;
  value: string | JSX.Element;
  labelSecondLine?: string | JSX.Element;
  valueSecondLine?: string | JSX.Element;
}

export function PaymentDetailsLineItem(props: PaymentDetailsLineItemProps) {
  const { iconType, label, labelSecondLine, value, valueSecondLine } = props;
  const hasSecondLine = isDefined(labelSecondLine) || isDefined(valueSecondLine);

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={3} sx={{ width: "100%", alignItems: "center" }}>
        <CbhIcon type={iconType} size="small" />
        <Stack
          direction="row"
          spacing={3}
          sx={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}
        >
          {typeof label === "string" ? (
            <Text semibold variant="body1">
              {label}
            </Text>
          ) : (
            label
          )}
          {typeof value === "string" ? (
            <Text semibold variant="body2" sx={{ textAlign: "right", lineClamp: 1 }}>
              {value}
            </Text>
          ) : (
            value
          )}
        </Stack>
      </Stack>
      {hasSecondLine && (
        <Stack
          direction="row"
          spacing={3}
          sx={(theme) => ({
            paddingLeft: theme.spacing(7),
            justifyContent: "space-between",
            alignItems: "center",
          })}
        >
          {
            // make sure to always render the Text, even if labelSecondLine is undefined
            // otherwise the value will not be pushed to the right
            isNil(labelSecondLine) || typeof labelSecondLine === "string" ? (
              <Text variant="caption" sx={{ color: (theme) => theme.palette.text.tertiary }}>
                {labelSecondLine}
              </Text>
            ) : (
              labelSecondLine
            )
          }
          {typeof valueSecondLine === "string" ? (
            <Text
              variant="caption"
              sx={{ color: (theme) => theme.palette.text.tertiary, textAlign: "right" }}
            >
              {valueSecondLine}
            </Text>
          ) : (
            valueSecondLine
          )}
        </Stack>
      )}
    </Stack>
  );
}
